const URL_RE = /https?:\/\/[^\s<>"'`]+/gi;

function unbalanced(value, open, close) {
  let n = 0;
  for (const ch of value) {
    if (ch === open) n += 1;
    else if (ch === close) n -= 1;
  }
  return n < 0;
}

function trimUrlTail(raw) {
  let value = raw;
  while (value) {
    const last = value[value.length - 1];
    if (/[.,;:!?，。；：！？、]/.test(last)) {
      value = value.slice(0, -1);
      continue;
    }
    if (last === ")" && unbalanced(value, "(", ")")) {
      value = value.slice(0, -1);
      continue;
    }
    if (last === "]" && unbalanced(value, "[", "]")) {
      value = value.slice(0, -1);
      continue;
    }
    break;
  }
  return value;
}

function safeHref(raw) {
  if (!raw || raw.length > 2048) return "";
  try {
    const url = new URL(raw);
    if (url.protocol !== "http:" && url.protocol !== "https:") return "";
    return url.href;
  } catch {
    return "";
  }
}

/** Split chat text into plain runs and http(s) links. Trailing punctuation stays outside the link. */
export function splitChatLinks(text) {
  const src = String(text ?? "");
  const out = [];
  URL_RE.lastIndex = 0;
  let last = 0;
  for (const match of src.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    const raw = match[0];
    if (start > last) out.push({ text: src.slice(last, start) });
    const trimmed = trimUrlTail(raw);
    const href = safeHref(trimmed);
    if (href) out.push({ text: trimmed, href });
    else out.push({ text: trimmed });
    if (trimmed.length < raw.length) out.push({ text: raw.slice(trimmed.length) });
    last = start + raw.length;
  }
  if (last < src.length) out.push({ text: src.slice(last) });
  if (!out.length) out.push({ text: src });
  return out;
}
